module.exports = __webpack_public_path__ + "static/media/icon_chat_bloco.402224a0.svg";